import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a826b40c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a826b40c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a826b40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a826b40c')) {
      api.createRecord('a826b40c', component.options)
    } else {
      api.reload('a826b40c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a826b40c&scoped=true", function () {
      api.rerender('a826b40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/archives/index.vue"
export default component.exports